import React from 'react';
import { IoCheckmarkCircle } from 'react-icons/io5';
import './TarefaCard.scss';

interface TarefaCardProps {
  titulo: string;
  descricao: string;
  concluida: boolean;
  icone: string;
}

export const TarefaCard: React.FC<TarefaCardProps> = ({
  titulo,
  descricao,
  concluida,
  icone
}) => {
  return (
    <div 
      className={`tarefa-card ${concluida ? 'tarefa-card--concluida' : ''}`}
      role="listitem"
      aria-label={`Tarefa: ${titulo}. ${concluida ? 'Concluída' : 'Pendente'}`}
    >
      {concluida && (
        <div className="tarefa-card__check" aria-hidden="true">
          <IoCheckmarkCircle size={24} />
        </div>
      )}
      <div className="tarefa-card__icone" aria-hidden="true">
        <img src={icone} alt="" />
      </div>
      <div className="tarefa-card__content">
        <h3 className="tarefa-card__titulo" tabIndex={0}>{titulo}</h3>
        <p className="tarefa-card__descricao" tabIndex={0}>{descricao}</p>
        <span className="sr-only">{concluida ? 'Status: concluída' : 'Status: pendente'}</span>
      </div>
    </div>
  );
};
